var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.4a.6.6 0 010 1.2V2.4zM12.4 8a.6.6 0 111.2 0h-1.2zM5 12.4h6v1.2H5v-1.2zM3.6 5v6H2.4V5h1.2zM8 3.6H5V2.4h3v1.2zm4.4 7.4V8h1.2v3h-1.2zm-10-6A2.6 2.6 0 015 2.4v1.2A1.4 1.4 0 003.6 5H2.4zm8.6 7.4a1.4 1.4 0 001.4-1.4h1.2a2.6 2.6 0 01-2.6 2.6v-1.2zm-6 1.2A2.6 2.6 0 012.4 11h1.2A1.4 1.4 0 005 12.4v1.2zM6.454 6.413a.6.6 0 00-.908.784l.908-.784zM7.895 9l-.454.392a.6.6 0 00.873.038L7.895 9zm4.524-3.57a.6.6 0 10-.838-.86l.838.86zM5.546 7.197L7.44 9.392l.908-.784-1.895-2.195-.908.784zM8.314 9.43l4.105-4-.838-.86-4.104 4 .837.86z",
    fill: "#599AF5"
  })));
}
export default __webpack_public_path__ + "static/task_mail.ba64de3d.svg";
export { SvgTaskMail as ReactComponent };